<template>
    <div class="main-box"></div>
</template>
<script>
export default {
    name: 'Index',
    mounted() {
        if (this.$store.state.pageType && !this.$route.query.type) {
            this.$router.push({
                path: '/index',
                query: {
                    type: this.$store.state.pageType
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.main-box {
    overflow: auto;
    position: relative;
    height: 100%;
    background: url('../assets/img/background.jpg') no-repeat center center;
    background-size: cover;
}
</style>
